import { render, staticRenderFns } from "./Infrarouges.vue?vue&type=template&id=0f6f5d1a&scoped=true&"
import script from "./Infrarouges.vue?vue&type=script&lang=js&"
export * from "./Infrarouges.vue?vue&type=script&lang=js&"
import style0 from "./Infrarouges.vue?vue&type=style&index=0&id=0f6f5d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6f5d1a",
  null
  
)

export default component.exports